import {brandConfigMap} from "@/brand";
import store from "@/store";

export function setBrandConfig() {
    const domain = window.origin;
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    store.commit('setBrandConfig', brandConfig);
}
